const translations: Record<string, JSX.Element> = {
  pt: (
    <>
      <p>Este é um museu digital.</p>
      <p>Aqui são expostas obras criadas por Isabela Reinhold.</p>
      <p>Utilize as setas para navegar pelo museu e aperte "A" para saber mais sobre cada obra.</p>
    </>
  ),
  en: (
    <>
      <p>This is a digital museum.</p>
      <p>Here you can see paintings by Isabela Reinhold.</p>
      <p>Use the arrow keys to navigate and press "A" to know more about the paintings.</p>
    </>
  )
}

const Intro: React.FC = () => {
  return (
    <div>
      {
        translations[window.location.pathname.substring(1)] ||
        translations['pt']
      }
    </div>
  );
}

export default Intro;
